export default class LanguageSelector {
	private currentLanguage: HTMLElement;
	private languageList: HTMLElement;
	private readonly documentClickCallback: EventListener;

	public constructor() {
		this.documentClickCallback = (event: MouseEvent) => this.hide(event);
		this.currentLanguage = document.querySelector('.language-selector .current-language');
		this.languageList = document.querySelector('.language-selector .language-list');
		this.currentLanguage?.addEventListener('click', (event) => this.toggleVisibility(event));
	}

	private toggleVisibility(event: MouseEvent): void {
		event.preventDefault();

		if (this.currentLanguage.classList.contains('is-visible')) {
			document.body.removeEventListener('click', this.documentClickCallback);
		} else {
			document.body.addEventListener('click', this.documentClickCallback);
		}
		this.currentLanguage.classList.toggle('is-visible');
		this.languageList.toggleAttribute('inert');
	}

	private hide(event: MouseEvent): void {
		const target: Element = event.target as Element;

		if (!target.classList.contains('current-language')) {
			document.body.removeEventListener('click', this.documentClickCallback);
			this.currentLanguage.classList.remove('is-visible');
			this.languageList.setAttribute('inert', '');
		}
	}
}
